import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, ElementRef, ViewChild, Renderer2, AfterContentInit, OnDestroy } from '@angular/core';
import { MapService } from '../../../services/map/map.service';
import { printConstants } from '../print-control/print-control.component';
import { Subscription } from 'rxjs/Subscription';
import { LoginService } from '../../../services/login/login.service';
declare var $;//jquery

@Component({
    selector: 'app-identify-control',
    templateUrl: './identify-control.component.html',
    styleUrls: ['./identify-control.component.css']
})
export class IdentifyControlComponent implements OnInit, OnChanges, AfterContentInit, OnDestroy {
    @Output() closeTools = new EventEmitter<string>();
    @Output() private printMap = new EventEmitter<any>();
    @Input() results: any;
    @Input() actualScale: any;
    private previewProperties: Object;
    private moreInfo: Object;
    private showLeftPanel = true;
    private featureInfoResults = {};
    private resultsLeftPanel = {};
    private coordinates = [];
    private srs = "";
    private translateParams = {};
    private refcad = "";
    subscription: Subscription;
    constructor(
        private mapService: MapService,
        public loginService: LoginService
    ) {
        this.subscription = this.mapService.getFeatureInfoPanel().subscribe(resultsLeftPanel => {
            this.resultsLeftPanel = resultsLeftPanel;
            setTimeout(() => $("#infoResultsHTML").html($(resultsLeftPanel)), 250);
        });
    }

    ngOnInit() {
        console.debug("IdentifyControlComponent - ngOnInit");
    }

    ngAfterContentInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        console.debug(">>> IdentifyControlComponent: ngOnChanges");
        try {
            if (typeof (changes.results) !== "undefined" && typeof (changes.results.currentValue) !== "undefined") {
                this.extractPreview(changes.results.currentValue);
            }
        }
        catch (e) { console.warn("Ups, hi ha hagut algun problema al ngOnChanges del identify-control.component.ts", e); }
    }

    private extractPreview(featureInfoResults): void {

        
        // reset previous info
        $("#infoResultsHTML").html('<i id="info-panel-loading-icon"></i>');

        this.featureInfoResults = featureInfoResults;
        try {
            if (featureInfoResults.features.length > 0) {
                let features = featureInfoResults.features; //Array
                this.coordinates = featureInfoResults.coordinates;
                let voronoiFeatureProperties = null;
                let parcelFeatureProperties = null;
                for( let featureIndex in features ){
                    let feature = features[featureIndex];
                    if(feature["id"].indexOf("parcel")>=0){
                        parcelFeatureProperties = feature["properties"];
                    }else{
                        voronoiFeatureProperties = feature["properties"];
                    }
                    if(parcelFeatureProperties && voronoiFeatureProperties){
                        break;
                    }
                }
                               
                this.previewProperties = voronoiFeatureProperties;
                if(  parcelFeatureProperties != null ){
                    this.refcad = parcelFeatureProperties.pa_parcel_illa_cadastral + parcelFeatureProperties.pa_parcel_txt + parcelFeatureProperties.pa_parcel_full
                }                
                this.srs = featureInfoResults.srs;
                this.translateParams = {
                    coordenadaX: this.coordinates[0],
                    coordenadaY: this.coordinates[1],
                    refcad:this.refcad
                }
                
            }
        }
        catch (e) {
            console.warn("Ups, hi ha hagut algun problema al extractPreview del identify-control.component.ts", e);
        }
    }

    public closeIdentifyPanel() {
        this.closeTools.emit("identify");
    }

    public openStreetView() {
        let coordinates = this.mapService.getCoordinatesForInfo();

        var coordGeo = ol.proj.transform(coordinates, this.srs, "EPSG:4326");

        //console.log(point.y+', '+point.x);
        window.open('http://maps.google.cat?layer=c&cbll=' + coordGeo[1] + ',' + coordGeo[0], 'Street View', 'fullscreen=0, height=700, width=800');
    }

    private printFeatureInfo(format: string|undefined) {
        let infoParams = {};
        let indexParams = 0;

        // Show print loading animation
        $("#printStateLoading").show();
        $("#printStateFinished").hide();

        $('#taulaInfo td').each(function(i, v) {
            let objData = $(v).data();
            if (typeof (objData["columnname"]) !== "undefined") {
                let propertyName = objData["columnname"];
                if (typeof (infoParams[propertyName]) !== "undefined") {
                    infoParams[propertyName] += "<br/>" + objData["columnvalue"];
                } else {
                    infoParams[propertyName] = objData["columnvalue"];
                }
            }
        });
        
        infoParams["width"] = 18.48;
        infoParams["height"] = 17.63;
        infoParams["scale"] = this.actualScale;
        infoParams["plantilla"] = printConstants.feature_info_template;
        infoParams["size"] = "A4";
        infoParams["orientacio"] = "V";
        infoParams["format"] = format || "pdf";

        this.printMap.emit({
            state: "true",
            config: infoParams
        });
    }


    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/tools/identify-control/identify-control.component.ts